import { format, type Locale, parseISO } from 'date-fns'
import { de, enUS, es, fr, it, ja, ko, nl, pl, pt, ru, tr, zhCN, zhTW } from 'date-fns/locale'

import type { Language } from '@/shared/providers'

const localeByLang = {
    cn: zhCN,
    de,
    en: enUS,
    es,
    fr,
    it,
    ja,
    ko,
    nl,
    pl,
    pt,
    ru,
    tr,
    tw: zhTW,
} satisfies Record<Language, Locale>

export function formatPublishingDate(publishTime: string, lang: Language) {
    const date = parseISO(publishTime)

    // English keeps the legacy moment `LL` form (no ordinal); other languages use their idiomatic long date.
    const localeDate =
        lang === 'en'
            ? format(date, 'MMMM d, yyyy', { locale: enUS })
            : format(date, 'PPP', { locale: localeByLang[lang] })

    return {
        localeDate,
        dateTime: format(date, 'yyyy-MM-dd'),
    }
}
